import React, { useEffect, useState } from "react";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import {
  EditUserAPI,
  getAdminInfoAPI,
} from "../../../../Api/PanelAdminServices";
import Style from "./EditAdminContainer.module.scss";
import Resizer from "react-image-file-resizer";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Select from "react-select";
const EditAdminContainer = () => {
  const [photo, setPhoto] = useState("");
  const [disable, setDisable] = useState(false);
  const [userInfoState, setUserInfoState] = useState();
  const [chooseAccess, setChooseAccess] = useState("");

  useEffect(() => {
    getAdminHandler();
  }, []);
  const path = window.location.pathname.split("/");
  const getAdminHandler = () => {
    getAdminInfoAPI(path[2], (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setUserInfoState(res.info);
        } else {
          console.log(res.message);
        }
      } else {
        console.log(res);
      }
    });
  };

  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const accessLevel = [
    {
      value: "1",
      label: "ادمین اصلی",
      status: "0",
    },
    {
      value: "2",
      label: "نا معلوم",
      status: "1",
    },
    {
      value: "3",
      label: "پشتیبانی",
      status: "2",
    },
  ];

  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      id: path[2],
      first_name: data.name,
      last_name: data.lName,
      phone: data.phone,
      access_level: data.phone,
      email: data.email ? data.email : "",
      user_type: "admin",
      photo: photo,
      access_level:
        chooseAccess !== undefined
          ? chooseAccess.status
          : userInfoState.access_level,
    };
    EditUserAPI(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setDisable(false);
      } else {
        errorToast(res.message);
        setDisable(false);
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ویرایش ادمین "} />
      {userInfoState && (
        <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
          <div className={Style.inputHolder}>
            <section className={Style.logoPart}>
              <div className={Style.titleLogo}>بارگذاری تصویر</div>
              <div className={Style.uploadImage}>
                <img
                  src={
                    photo === ""
                      ? `https://cdn.barest.ir/deliver/photo/${userInfoState.photo}.jpg`
                      : photo
                  }
                  alt=""
                />
              </div>
              <input
                id={"uploadPhoto"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadPhoto(e.target.files[0])}
              />
              <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
                <FontAwesomeIcon className={Style.icon} icon={faImage} />
              </label>
              <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
            </section>

            <input
              className={errors.name ? Style.errorInput : Style.inputPart}
              placeholder={"نام"}
              defaultValue={userInfoState.first_name}
              {...register("name", { required: true })}
            />

            <input
              className={errors.lName ? Style.errorInput : Style.inputPart}
              placeholder={"نام خانوادگی "}
              defaultValue={userInfoState.last_name}
              {...register("lName", { required: true })}
            />

            <input
              className={errors.phone ? Style.errorInput : Style.inputPart}
              placeholder={"شماره همراه"}
              defaultValue={userInfoState.phone}
              {...register("phone", { required: true })}
            />
            <input
              className={Style.inputPart}
              placeholder={"ایمیل "}
              defaultValue={userInfoState.email}
              {...register("email")}
            />

            <Select
              onChange={setChooseAccess}
              options={accessLevel}
              placeholder={" سطح دسترسی"}
              className={Style.selectPart}
              defaultValue={accessLevel.filter(
                (option) => option.status === userInfoState.access_level
              )}
            />

            <button
              className={Style.btnStyle}
              type={"submit"}
              disabled={disable}
            >
              {disable ? "در حال ارسال اطلاعات" : "ذخیره کردن"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default EditAdminContainer;
